import React from "react";
import withProviders from "../hooks/withProviders";
import { Outlet } from "react-router-dom";
import { FilterProvider, InvestmentCommitteeFundDefaultFilters } from "../hooks/FilterContext";

const InvestmentCommitteeFundsLayout = () => <Outlet />

export default withProviders([FilterProvider, { defaultFilters: InvestmentCommitteeFundDefaultFilters }])(InvestmentCommitteeFundsLayout);